<template>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="solicitudes"
    show-select
    item-key="id_solicitud"
    sort-by="fecha_comprobacion"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title style="color:#1C2546;margin-top:40px">Solicitudes de gastos dentro de grupo</v-toolbar-title>
        <v-divider class="mx-4" inset vertical style="margin-top:30px"></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog"  max-width="700"  >  
          <v-card>
            <v-card-title>
              <span class="headline">Detalle de solicitud</span>
            </v-card-title>
            <v-card-text >
              <v-container >
                <v-row  >
                  <v-col cols="12" sm="6" md="12">
                    <v-select
                      v-model="editedItem.deudor"
                      :items="empleados"
                      :error-messages="selectErrors"
                      label="Deudor"
                      required
                      filled
                      item-text="nombre"
                      item-value="nombre"
                      :readonly ="readonlySelect"
                      @change="$v.select.$touch()"
                      @blur="$v.select.$touch()"
                    ></v-select>
                  </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="editedItem.fecha_comprobacion"
                            label="Fecha de comprobación"
                            append-icon="mdi-calendar"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="editedItem.fecha_comprobacion" @input="menu2 = false"></v-date-picker>
                      </v-menu>
                    </v-col>
                  <v-col cols="12" sm="6" md="6">
                      <v-select
                      v-model="editedItem.idconcepto"
                      :items="gastos"
                      item-value="id_gasto"
                      item-text="gasto"
                      label="Concepto"
                      data-vv-name="select"
                      required
                      @change="getCuenta()"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="12">
                     <v-select v-model="editedItem.idcuenta" :items="cuentas" item-text="cuenta" item-value="idcuenta" label="Cuenta"></v-select>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                  <v-select v-model="editedItem.tipo" :items="tipo" label="Tipo" data-vv-name="select" required></v-select>

                  </v-col>
                    <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="editedItem.importe" label="Importe"></v-text-field>
                  </v-col>
                   <v-col cols="12" sm="6" md="12">
                    <v-text-field v-model="editedItem.descripcion" label="Descripción"></v-text-field>
                  </v-col>
                   <v-col cols="12" sm="6" md="12">
                    <!--<v-text-field label="Comprobantes" v-model="editedItem.Documentos" ></v-text-field>-->
                    <h6 style="margin-bottom: 20px">Comprobantes</h6>
                    <v-data-table
                      :headers = "fileHeaders"
                      :items = "fileItems"
                      :items-per-page = "5"
                      class= "elevation-1"
                    >
                      <template v-slot:item.actionsFile="{ item }">
                        <v-icon
                          small
                          class="mr-2"
                          @click="downloadFile(item)"
                        >
                          mdi-download
                        </v-icon>
                        <v-icon
                          small
                          @click="deleteFile(item)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>
                  </v-col>
                    <v-col cols="12" sm="6" md="12">
                   <v-file-input
                      v-model="files"
                      ref="fileInput"
                      placeholder="Agregar comprobantes"
                      label="Comprobantes"
                      multiple
                      prepend-icon="mdi-paperclip"
                    >
                      <template v-slot:selection="{ text }">
                        <v-chip small label color="primary">{{ text }}</v-chip>
                      </template>
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="save">Actualizar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-row justify="center">
          <v-dialog v-model="dialogD" persistent max-width="290">
            <v-card>
              <v-card-title class="headline"> Eliminar solicitud </v-card-title>
              <v-card-text>
              ¿ Estás seguro de eliminar esta solicitud ?
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogD = false">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="borrar">Confirmar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
        <v-row justify="center">
          <v-dialog v-model="dialogAddGrupo" max-width="590">
            <v-card>
              <v-card-title class="headline"> Desagrupar solicitudes </v-card-title>
              <v-card-text>
                  ¿ Estás seguro de desagrupar las solicitudes seleccionadas?
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogAddGrupo = false">Cancelar</v-btn>
                <v-btn color="blue darken-1" text @click="DesaAgregarG">Confirmar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </v-toolbar>
      <div class="text-right" style="margin-top:35px">
        <v-row>
          <v-col style="margin-left: 25px" class="d-flex" cols="4">
            <v-text-field v-model="grupo.nombre" label="Nombre de grupo"></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="4"> 
            <v-text-field v-model="grupo.descripcion" label="Descripción"></v-text-field>
          </v-col>
        </v-row>
        <v-btn class="ma-2" tile color="primary" dark @click="guardarGrupo">
          <v-icon left>mdi-send</v-icon> Guardar datos generales
        </v-btn>
        <v-btn class="ma-2" tile color="error" dark @click="dialogAddGrupo = true">
          <v-icon left>mdi-send</v-icon> Desagrupar
        </v-btn>
      </div>
      <v-row class="justify-content-center col-lg-12">      
        <v-alert type="success" :value='alertSucess' close-text="Cerrar">
            {{ message }}
        </v-alert> 
        <v-alert type="error" :value='alertError' close-text="Cerrar">
            {{ message }}
        </v-alert> 
      </v-row>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import axios from "axios";
import router from '../router/index.js'

export default {
  name: "SolicitudComprobacion",
    data: () => ({
      grupo: {
        nombre: '',
        descripcion: ''
      },
      headers: [
          { text: "Fecha de Comprobación", value: "fecha_comprobacion", sortable: true },
          { text: "Deudor", align: "left", sortable: true, value: "deudor" },
          { text: "Concepto", value: "concepto" },
          { text: "Importe", value: "importe" },
          { text: "Cuenta", value: "cuenta" },
          { text: "Tipo", value: "tipo", sortable: true },
          { text: "Descripcion", value: "descripcion", sortable: true },
          { text: "Acciones", value: "actions", sortable: false }
      ],
      solicitudes: [],
      dialog: false,
      dialogD: false,
      dialogAddGrupo: false,
      editedIndex: -1,
      editedItem: {
        IdSolicitud: "",
        Documentos:"",
        Deudor: "",
        idconcepto: "",
        Estado: "",
        Tipo: "",
        Cuenta: "",
        idcuenta:"",
        importe: "",
        Descripcion: "",
        fecha_comprobacion: ""
      },
      fileHeaders: [
        {text: 'Archivo', value: 'file'},
        { text: "Acciones", value: "actionsFile", sortable: false }
      ],
      fileItems: [],
      files: null,
      empleados: [],
      menu2: false,
      tipo: ["Comprobación", "Anticipo"],
      cuentas: [       
        {cuenta :"GASTOS NO DEDUCIBLES", idcuenta:"1"},
        {cuenta :"VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"2"},
        {cuenta :"VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"3"},
        {cuenta :"GASTOS NO DEDUCIBLES", idcuenta:"4"},
        {cuenta :"ALQUILER TRANSPORTES", idcuenta:"5"},
        {cuenta :"ALQUILER TRANSPORTES ND", idcuenta:"6"},
        {cuenta :"VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"7"},
        {cuenta :"GASTOS NO DEDUCIBLES", idcuenta:"8"},
        {cuenta :"GASOLINA", idcuenta:"9"},
        {cuenta :"GASOLINA ND", idcuenta:"10"},
        {cuenta :"REEMBOLSO Y GASTOS VEHICULOS", idcuenta:"11"},
        {cuenta :"VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"12"},
        {cuenta :"GASTOS NO DEDUCIBLES", idcuenta:"13"},
        {cuenta :"VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"14"},
        {cuenta :"GASTOS NO DEDUCIBLES", idcuenta:"15"},
        {cuenta :"VIAJES Y GASTOS REEMBOLSADOS", idcuenta:"16"},
        {cuenta :"GASTOS NO DEDUCIBLES", idcuenta:"17"},
        {cuenta :"GASTOS COMUNES", idcuenta:"18"},
        {cuenta :"GASTOS COMUNES ND", idcuenta:"19"},
        {cuenta :"GASTOS COMUNES", idcuenta:"20"},
        {cuenta :"GASTOS COMUNES ND", idcuenta:"21"},
        {cuenta :"GASTOS DE LIBRERIA", idcuenta:"22"},
        {cuenta :"GASTOS DE LIMPIEZA", idcuenta:"23"},
        {cuenta :"MESSENGER SERVICES", idcuenta:"24"},
        {cuenta :"CUSTOMER GIFTS", idcuenta:"25"},
        {cuenta :"MEALS & ENTERTAINMENT", idcuenta:"26"},
        {cuenta :"MANTENIMIENTO VEHICULO", idcuenta:"27"},
        {cuenta :"MANTENIM DE MAT INFORMATICO", idcuenta:"28"},
      ],
      gastos: [
        { gasto: "Hotel", id_gasto: "1" },
        { gasto: "Alimentos", id_gasto: "2" },
        { gasto: "Renta de vehículo", id_gasto: "3" },
        { gasto: "Peaje", id_gasto: "4" },
        { gasto: "Gasolina", id_gasto: "5" },
        { gasto: "Avión", id_gasto: "6" },
        { gasto: "Autobús", id_gasto: "7" },
        { gasto: "Taxi", id_gasto: "8" },
        { gasto: "Estacionamiento", id_gasto: "9" },
        { gasto: "Despensa", id_gasto: "10" },
        { gasto: "Agua beber", id_gasto: "11" },
        { gasto: "Papelería", id_gasto: "12" },
        { gasto: "Limpieza", id_gasto: "13" },
        { gasto: "Mensajería", id_gasto: "14" },
        { gasto: "Regalos a clientes", id_gasto: "15" },
        { gasto: "Consumos de alimentos locales", id_gasto: "16" },
        { gasto: "Mtto auto", id_gasto: "17" },
        { gasto: "Gastos de celulares", id_gasto: "18" },
      ],
      alertError: false,
      alertSucess: false,
      message: '',
      selected: [],
    }),
    computed: {},
    watch: {},
    created () {},
    mounted() {
     //Config for axios
      axios.defaults.headers.common['access-token'] = this.$store.state.token;

      axios.interceptors.response.use(function (response){
          //console.log(response.data.message);
          if (response.data.message == 'Token inválida') {
              router.push({name: 'login', params: {errorToken: 'true'}});
          }else{
              return response;
          }
      });
      //End config for axios
      this.grupo = this.$route.params.item;
      this.getSolicitudesGrupo();
      this.getEmpleados();
    },
    methods: {
      getSolicitudesGrupo() {
        let idGrupo = this.grupo.id;
        axios.get("https://"+process.env.VUE_APP_URL+":3000/solicitudGrupo/"+idGrupo).then(res => {
          //console.log(res.data);
          this.solicitudes= res.data;
        });
      },
      editItem (item) {
        this.editedIndex = this.solicitudes.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.editedItem.importe = this.editedItem.importe.replace('US$','').replace('.00','').replace(/\s/g,'');
        //this.getImg();
        let documentosCadena = item.documentos;
        let arrayDocumentos = documentosCadena.split(";");
        this.fileItems = [];
        for (var i=0; i < arrayDocumentos.length; i++) {
          if (arrayDocumentos[i] != '') {  
            this.fileItems.push({
              file: arrayDocumentos[i].replace('documentacion/',''),
              IdSolicitud: item.id_solicitud
            }); 
          }
        }
        this.dialog = true
      },
      deleteItem (item) {
         this.editedIndex = this.solicitudes.indexOf(item)
         this.editedItem = Object.assign({}, item)
         this.dialogD = true
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      save () {
        let IdSolicitud = this.editedItem.id_solicitud;
        let idconcepto = this.editedItem.idconcepto;
        let Tipo = this.editedItem.tipo;
        let Cuenta = this.editedItem.cuenta;
        let idcuenta= this.editedItem.idcuenta;
        let importe = this.editedItem.importe;
        let Descripcion = this.editedItem.descripcion;
        let FechaComprobacion = this.editedItem.fecha_comprobacion;
        var data_f=new FormData()
        for(let x in this.files){
          data_f.append('files',this.files[x]);
        }
        data_f.append('id',IdSolicitud);
        data_f.append('Idconcepto',idconcepto);
        data_f.append('fechaC',FechaComprobacion);
        data_f.append('importe',importe);
        data_f.append('idcuenta',idcuenta);
        data_f.append('cuenta',Cuenta);
        data_f.append('tipo',Tipo);
        data_f.append('descripcion',Descripcion);
        axios.put("https://"+process.env.VUE_APP_URL+":3000/solicitud", data_f).then(function(){
          //console.log(res.data);
          //this.gastos = res.data;
          this.alert=true;
          this.files = null;
          this.getSolicitudesGrupo();
          this.close()
        });
      },
      guardarGrupo () {
        let igrupo = this.grupo.id;
        let nombre = this.grupo.nombre;
        let descripcion = this.grupo.descripcion;
        let usuario = this.$store.state.user.nombre;
        var c = {
          id: igrupo,
          nombre: nombre,
          descripcion: descripcion,
          usuario: usuario
        };
        axios.put("https://"+process.env.VUE_APP_URL+":3000/grupos/edit", c).then(function(){
          //console.log(res.data);
          this.message = "Grupo actualizado exitosamente";
          this.alertSucess = true;
          this.close()
        });
      },
      borrar () {
        this.dialogD = false
        let IdSolicitud = this.editedItem.id_solicitud;
        axios.delete("https://"+process.env.VUE_APP_URL+":3000/Deletesolicitud/"+IdSolicitud).then(function(){
          //console.log(res.data);
          this.message = "Solicitud eliminada"
          this.alertSucess=true;
          this.getSolicitudesGrupo();
          this.close()
        });
      },
      downloadFile(item){
        //console.log(item);
        axios({
          url: 'https://'+process.env.VUE_APP_URL+':3000/download/'+item.file,
          method: 'GET',
          responseType: 'blob', // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', item.file);
          document.body.appendChild(link);
          link.click();
        });
      },
      deleteFile(item){
        axios.post('https://"+process.env.VUE_APP_URL+":3000/delete/file',item)
        .then((response) => {            
            if(response.data.message === 'Archivo eliminado'){
              let arrayDocumentos = response.data.body.split(";");
              this.fileItems = [];
              for (var i=0; i < arrayDocumentos.length; i++) {
                if (arrayDocumentos[i] != '') {  
                  this.fileItems.push({
                    file: arrayDocumentos[i].replace('documentacion/',''),
                    IdSolicitud: item.IdSolicitud
                  }); 
                }
              }
              this.getSolicitudesGrupo();
            }
        });
      },
      getEmpleados: async function(){
        axios.get('https://"+process.env.VUE_APP_URL+":3000/select/empleados/comprobacion/' + this.$store.state.user.id_puesto)
        .then((response) => {
            //console.log(response);
            this.empleados = response.data;
            if(response.data.length <= 1){
              this.readonlySelect = true;
            }
        })
      },
      getCuenta() {
        var idg = this.editedItem.idconcepto;
        axios.get("https://"+process.env.VUE_APP_URL+":3000/cuentasgastos/" + idg).then(res => {
          this.cuentas = res.data;
        });
      },
      DesaAgregarG () {
        this.dialogAddGrupo = false
        var c = {
          solicitudes: this.selected,
        };
        axios.put("https://"+process.env.VUE_APP_URL+":3000/DesGruposolicitud", c).then(res => {
          //console.log(res.data);
          this.message = res.data.message;
          this.alertSucess = true;
          this.getSolicitudesGrupo();
        });
      },
    },
  }
</script>